'use client';
import React from "react";

import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {HeroSection} from "../components/HeroSection";
import {Section} from "../components/Section";
import {translations} from "../utils/translations";
import {LanguageSelector} from "../components/LanguageSelector";
import {useLanguage} from "../context/LanguageContext";

function Features({ t }: any) {
    return (
        <Section>
            <h2>{t.featuresTitle}</h2>
            <div className="grid">
                {t.features.map((f: any) => (
                    <div key={f.title} className="card">
                        <h3>{f.title}</h3>
                        <p>{f.desc}</p>
                    </div>
                ))}
            </div>
        </Section>
    );
}

function HowItWorks({ t }: any) {
    return (
        <Section>
            <h2>{t.howItWorksTitle}</h2>
            <div className="grid">
                {t.steps.map((s: any) => (
                    <div key={s.title} className="card">
                        <h3>{s.title}</h3>
                        <p>{s.desc}</p>
                    </div>
                ))}
            </div>
        </Section>
    );
}

function Testimonial({ t }: any) {
    return (
        <Section>
            <blockquote>“{t.testimonialQuote}”</blockquote>
            <blockquote>“{t.testimonialQuote2}”</blockquote>
        </Section>
    );
}


export default function HomePage() {
    const { lang } = useLanguage();
    const t = translations[lang];

    return (
        <main className="container">
            <LanguageSelector/>
            <Header t={t} isBackButtonVisible={false} />
            <HeroSection t={t} />
            <Features t={t} />
            <HowItWorks t={t} />
            <Testimonial t={t} />
            <Footer t={t} />
        </main>
    );
}
